module.exports = "/_next/static/files/92251d0089a559e3822b55512147fd95.svg";